import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleFilledIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 19.5,
			fill: "#03A65B",
			stroke: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_2859_1280)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M26.629 14.2792C27.0853 14.6847 27.1263 15.3833 26.7208 15.8395L18.0351 25.611L13.2792 20.2606C12.8737 19.8044 12.9147 19.1057 13.371 18.7002C13.8272 18.2947 14.5258 18.3358 14.9314 18.792L18.0351 22.2837L25.0686 14.3709C25.4742 13.9147 26.1728 13.8736 26.629 14.2792Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2859_1280",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(13 13)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCheckCircleFilledIcon);
export default ForwardRef;
